import { render, staticRenderFns } from "./admission-date-anniversary-component.vue?vue&type=template&id=5687222a&scoped=true&"
import script from "./admission-date-anniversary-component.vue?vue&type=script&lang=ts&"
export * from "./admission-date-anniversary-component.vue?vue&type=script&lang=ts&"
import style0 from "./admission-date-anniversary-component.vue?vue&type=style&index=0&id=5687222a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5687222a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCol,VRow,VToolbar,VToolbarTitle})
